export default __webpack_public_path__ + "static/camera_w.893e77d1da6fa2345350fd2a67645471.png";